<template>
  <el-row class="dormitory-log-main">
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="已启用"
                   name="old"></el-tab-pane>
      <el-tab-pane label="未启用"
                   name="new"></el-tab-pane>
    </el-tabs>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="设备编号:"
                      prop="sn">
          <el-input v-model.trim="searchForm.sn"
                    placeholder="设备编号"></el-input>
        </el-form-item>
        <el-form-item label="设备名称:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="设备名称"></el-input>
        </el-form-item>
        <el-form-item label="房间名称:"
                      prop="room_name">
          <el-input v-model.trim="searchForm.room_name"
                    placeholder="房间名称"></el-input>
        </el-form-item>
        <el-form-item label="设备型号:"
                      prop="lock_model">
          <el-input v-model.trim="searchForm.lock_model"
                    placeholder="设备型号"></el-input>
        </el-form-item>
        <el-form-item label="设备类型:"
                      prop="dev_type">
          <el-select v-model="searchForm.dev_type"
                     placeholder="请选择设备类型">
            <el-option v-for="item in devTypeList"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域:"
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 在线状态 1在线 0不在线 -->
        <el-form-item label="在线状态:"
                      prop="online">
          <el-select v-model="searchForm.online"
                     placeholder="在线状态">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="在线"
                       value="1"></el-option>
            <el-option label="离线"
                       value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <!-- <el-button type="primary"
                 @click="handleAdd">添加</el-button> -->
      <!-- <el-button type="primary"
                 @click="multipleAct">批量注销</el-button> -->
      <el-button v-has="'/lock/allDel'"
                 type="primary"
                 @click="multipleDel">一键删除介质</el-button>
      <el-dropdown v-has="'/lock/typeDel'"
                   class="ml-10 mr-10"
                   placement="bottom"
                   @command="handleKind">
        <el-button type="primary">分类删除介质<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in medList"
                            :key="item.code"
                            :command="item.code">{{item.name}}</el-dropdown-item>
          <el-dropdown-item v-if="!medList.length">暂无分类</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-has="'/lock/hisClear'"
                 type="primary"
                 @click="multipleHisClear">清除锁内记录</el-button>
      <el-button v-has="'/lock/period'"
                 type="primary"
                 @click="sendTime">下发时间组</el-button>
      <el-button v-has="'/lock/holiday'"
                 type="primary"
                 @click="sendHoliday">下发假日组</el-button>
      <el-dropdown v-has="'/lock/workMode'"
                   class="ml-10 mr-10"
                   placement="bottom"
                   @command="handleWorkMode">
        <el-button type="primary">工作模式<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="0">正常模式</el-dropdown-item>
          <el-dropdown-item command="1">常开模式</el-dropdown-item>
          <el-dropdown-item command="2">常闭模式</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'online'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="danger"> off </el-tag>
              <el-tag v-else
                      type="success"> on </el-tag>
            </template>
            <template v-else-if="item.prop === 'ol_mode'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="danger"> off </el-tag>
              <el-tag v-else
                      type="success"> on </el-tag>
            </template>
            <template v-else-if="item.prop === 'work_mode'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="success"> 正常 </el-tag>
              <el-tag v-else-if="scope.row[item.prop] === '1'"
                      type="warning"> 常开 </el-tag>
              <el-tag v-else-if="scope.row[item.prop] === '2'"
                      type="info"> 常闭 </el-tag>
              <el-tag v-else
                      type="danger"> 未知 </el-tag>
            </template>
            <template v-else-if="item.prop === 'door_open'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="danger"> 关 </el-tag>
              <el-tag v-else
                      type="success"> 开 </el-tag>
            </template>
            <el-progress v-else-if="item.prop === 'electricity'"
                         :text-inside="true"
                         :stroke-width="15"
                         :percentage="Number(scope.row[item.prop])"
                         :color="customColors"></el-progress>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         :width="150">
          <!-- :width="activeName === 'old' ? 280 : 150" -->
          <template slot-scope="scope">
            <el-button v-has="'/lock/info'"
                       plain
                       if="activeName === 'old'"
                       size="mini"
                       type="primary"
                       @click="handleDetail(scope.row)">详情</el-button>
            <el-popover v-has="'/lock/edit'"
                        placement="bottom"
                        trigger="click">
              <el-button v-has="'/lock/edit'"
                         size="mini"
                         type="text"
                         @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-has="'/lock/getLora'"
                         size="mini"
                         type="text"
                         @click="handleConfig(scope.row)">配置</el-button>
              <el-button v-has="'/lock/getBlue'"
                         size="mini"
                         type="text"
                         @click="handleBlue(scope.row)">蓝牙</el-button>
              <el-button v-has="'/lock/getStat'"
                         v-if="activeName === 'old'"
                         size="mini"
                         type="text"
                         @click="handleStat(scope.row)">检测</el-button>
              <el-button v-has="'/lock/replace'"
                         v-if="activeName === 'old'"
                         size="mini"
                         type="text"
                         @click="handleChange(scope.row)">更换</el-button>
              <!-- <el-button size="mini"
                       type="danger"
                       @click="handleDestory(scope.row)">注销</el-button> -->
              <el-button slot="reference"
                         plain
                         size="mini"
                         type="primary"
                         style="margin-left: 10px;">更多</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <!-- 详情 -->
    <lock-detail v-if="showDetailModal"
                 :isShow="showDetailModal"
                 :data="detailID"
                 @handleClose="closeDetailModal"></lock-detail>
    <!-- 配置 -->
    <lock-config v-if="showConfigModal"
                 :isShow="showConfigModal"
                 :data="conifgData"
                 @handleClose="closeConfigModal"></lock-config>
    <!-- 蓝牙 -->
    <lock-blue v-if="showBlueModal"
               :isShow="showBlueModal"
               :data="blueData"
               @handleClose="closeBlueModal"></lock-blue>
    <!-- 实时 -->
    <lock-stat v-if="showDetailStat"
               :isShow="showDetailStat"
               :data="detaStat"
               @handleClose="closeStat"></lock-stat>
    <!-- 编辑 -->
    <lock-edit v-if="showEditModal"
               :isShow="showEditModal"
               :data="editData"
               @handleClose="closeEditModal"></lock-edit>
    <!-- 更换 -->
    <change-lock v-if="showChangeModal"
                 :isShow="showChangeModal"
                 :data="changeData"
                 @handleClose="closeChange"></change-lock>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import LockStat from '@/views/device/lock/LockStat'
import LockDetail from '@/views/device/lock/LockDetail'
import LockConfig from '@/views/device/lock/LockConfig'
import LockBlue from '@/views/device/lock/LockBlue'
import LockEdit from '@/views/device/lock/LockEdit'
import ChangeLock from '@/views/device/lock/ChangeLock'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: {
    LockDetail,
    Pagination,
    LockStat,
    LockConfig,
    LockBlue,
    LockEdit,
    ChangeLock
  },
  data() {
    return {
      activeName: 'old',
      medList: [],
      devTypeList: [],
      areaList: [],
      searchForm: {
        name: '',
        room_name: '',
        lock_model: '',
        dev_type: '',
        area_id: '',
        online: '',
        sn: ''
      },
      tableTitle: [
        {
          prop: 'sn',
          name: '设备编号',
          width: '120'
        },
        {
          prop: 'name',
          name: '设备名称',
          width: '120'
        },
        {
          prop: 'lock_model',
          name: '设备型号',
          width: '100'
        },
        {
          prop: 'lock_med',
          name: '设备介质',
          width: '150'
        },
        {
          prop: 'area_names',
          name: '所属区域',
          width: '260'
        },
        {
          prop: 'room_name',
          name: '房间名称',
          width: '100'
        },
        // {
        //   prop: 'door_open',
        //   name: '门状态',
        //   width: '100'
        // },
        {
          prop: 'dev_type',
          name: '类型',
          width: '100'
        },
        {
          prop: 'gate_name',
          name: '网关',
          width: '230'
        },
        {
          prop: 'ol_mode',
          name: '联机模式',
          width: '100'
        },
        {
          prop: 'work_mode',
          name: '工作模式',
          width: '100'
        },
        {
          prop: 'online',
          name: '在线',
          width: '80'
        },
        {
          prop: 'electricity',
          name: '电量',
          width: '80'
        },
        {
          prop: 'gate_channel',
          name: '通道号',
          width: '80'
        },
        {
          prop: 'frequency',
          name: '频率',
          width: '80'
        },
        {
          prop: 'speed_rate',
          name: '空口速率',
          width: '80'
        },
        {
          prop: 'gate_addr',
          name: '通道地址',
          width: '80'
        },
        {
          prop: 'ver',
          name: '版本',
          width: '80'
        },
        {
          prop: 'regtime',
          name: '注册时间',
          width: '160'
        },
        {
          prop: 'remarks',
          name: '备注',
          width: '100'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 详情相关
      showDetailModal: false,
      // 实时相关
      showDetailStat: false,
      detailID: -1,
      // 定义进度条颜色
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#67c23a', percentage: 100 }
      ],
      // 配置相关
      showConfigModal: false,
      conifgData: {},
      // 蓝牙配置
      showBlueModal: false,
      blueData: {},
      //实时
      detaStat: {},
      // 编辑
      showEditModal: false,
      editData: {},
      // 更换
      showChangeModal: false,
      changeData: {},
      tmpArr: []
    }
  },
  created() {
    this.getList()
    this.getItemList('lock_med', 'medList')
    this.getItemList('dev_type', 'devTypeList')
    this.getAreaTree()
  },
  methods: {
    handleAdd() {
      let datas = {
        frequency: '476302',
        gate_addr: '00001292',
        gate_channel: '4',
        gate_sn: 'C23729726603701800000011',
        id: '4',
        dev_type: '02',
        name: 'hhhh23',
        online: '1',
        regtime: '2021-01-04 17:37:21',
        remarks: '123123123',
        room_id: '2',
        sn: 'hhh23',
        speed_rate: '14',
        ver: '03'
      }
      fetch.addLock({ ...datas }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getList()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getLockList({
          type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 获取介质类型
    getItemList(code, org) {
      fetch.getItemList({ type_code: code }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this[org] = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    handleClick() {
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 批量注销
    multipleAct() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定注销选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            console.log(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要注销的设备后重试')
      }
    },
    // 清除锁内历史记录
    multipleHisClear() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定清除选中设备的历史记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.sn
              })
              .join(',')
            fetch.lockHisClear({ sn: selectIds }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.getList()
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要删除的设备后重试')
      }
    },

    // 一键删除
    multipleDel() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中设备的介质数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.sn
              })
              .join(',')
            fetch.delLockMed({ sn: selectIds }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.getList()
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要删除的设备后重试')
      }
    },
    // 分类删除
    handleKind(type) {
      if (!type) {
        return
      }
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中设备的该类介质数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.sn
              })
              .join(',')
            fetch.delLockTypeMed({ sn: selectIds, lock_med: type }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.getList()
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要删除的设备后重试')
      }
    },
    // 下发时间组
    sendTime() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定下发时间组到选中的设备数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.sn
              })
              .join(',')
            fetch.sendTime({ sn: selectIds }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.getList()
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要下发时间组的设备后重试')
      }
    },
    // 下发假日组
    sendHoliday() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定下发假日组到选中设备的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.sn
              })
              .join(',')
            fetch.sendHoliday({ sn: selectIds }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.getList()
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要下发假日组的设备后重试')
      }
    },
    // 设置工作模式
    handleWorkMode(type) {
      if (!type) {
        return
      }
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否对选定设备进行工作模式设置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.sn
              })
              .join(',')
            fetch.setDevWorkMode({ sn: selectIds, lock_mode: type }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.getList()
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要操作的设备')
      }
    },
    // 详情
    handleDetail(data) {
      this.showDetailModal = true
      this.detailID = data.id
    },
    closeDetailModal() {
      this.showDetailModal = false
    },
    //实时
    closeStat() {
      this.showDetailStat = false
    },
    handleStat(data) {
      this.showDetailStat = true
      this.detaStat = data.sn
    },
    // 配置
    handleConfig(data) {
      this.showConfigModal = true
      this.conifgData = {
        id: data.id,
        sn: data.sn,
        channel: data.gate_channel
      }
    },
    closeConfigModal() {
      this.showConfigModal = false
    },
    //蓝牙
    handleBlue(data) {
      this.showBlueModal = true
      this.blueData = {
        id: data.id,
        sn: data.sn
        // channel: data.gate_channel
      }
    },
    closeBlueModal() {
      this.showBlueModal = false
    },
    // 更换
    handleChange(data) {
      this.showChangeModal = true
      this.changeData = {
        id: data.id
      }
    },
    closeChange() {
      this.showChangeModal = false
    },
    // 编辑
    handleEdit(data) {
      this.showEditModal = true
      this.editData = {
        id: data.id
      }
    },
    closeEditModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showEditModal = false
    },
    // 注销
    handleDestory(data) {
      this.$confirm('是否确定注销该设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.destroyLock(data.id)
        })
        .catch(() => {})
    },
    // 注销设备
    destroyLock(ids) {
      fetch.editLock({ id: ids, online: '0' }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getList()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less">
.dormitory-log-main {
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #fff;
    border-bottom-color: #409eff;
  }
}
</style>
